import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  orgDetails: [],
};

const organisationDetailsSlice = createSlice({
  name: "organisationDetails",
  initialState,
  reducers: {
    setOrganisationDetails: (state, action) => {
      state.orgDetails = action.payload;
    },
    clearOrganisationDetails: (state) => {
      state.orgDetails = [];
    },
  },
});

export const { setOrganisationDetails, clearOrganisationDetails } =
  organisationDetailsSlice.actions;

export default organisationDetailsSlice.reducer;
